import {Location} from 'history';
import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {Prompt, useHistory} from 'react-router';
import AlertDialog from '../alert/AlertDialog';
import {messages} from './routeLeaving.translations';

interface Props {
  when?: boolean;
}

const RouteLeavingGuard = ({when}: Props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const {formatMessage} = useIntl();
  const history = useHistory();

  const closeModal = () => {
    setModalVisible(false);
  };
  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };
  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };
  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location
      history.push(`${lastLocation.pathname}${lastLocation.search}`);
    }
  }, [confirmedNavigation, lastLocation, history]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation}/>
      <AlertDialog
        open={modalVisible}
        title={formatMessage(messages['routeLeaving.discardChanges'])}
        text={formatMessage(messages['routeLeaving.description'])}
        onCancel={closeModal}
        onAccept={handleConfirmNavigationClick}
      />
    </>
  );
};
export default RouteLeavingGuard;
